import { cn } from "@/lib/utils";

// "A Legacy Forge Collective Company" endorsement — reusable across pages.
export const CollectiveEndorsement = ({ className = "", tone = "dark" }) => {
  const isLight = tone === "light";
  return (
    <div
      className={cn("flex items-center gap-3", className)}
      data-testid="collective-endorsement"
    >
      <span
        className={cn(
          "h-px w-8",
          isLight ? "bg-legacy-gold/50" : "bg-legacy-gold/60"
        )}
        aria-hidden="true"
      />
      <span
        className={cn(
          "text-xs md:text-sm tracking-[0.18em] uppercase font-medium",
          isLight ? "text-legacy-gold" : "text-legacy-gold"
        )}
      >
        A Legacy Forge Collective Company
      </span>
    </div>
  );
};
